import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { SvgIcon } from '../Icon';
import { IStyled } from '../../styles/types';

interface IProps extends IStyled {
  iconSize: number;
  message: string;
  link?: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 24px;
`;
const TextBox = styled.div`
  flex: 0 0 auto;
  text-align: center;
`;
const Message = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${theme.colors.secondary800};
`;
const StyledLink = styled.a`
  display: inline-block;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: ${theme.colors.mainBlue};
  &:hover {
    text-decoration: underline;
    color: ${theme.colors.mainBlue};
  }
`;

const NoDataPlaceholder = ({ iconSize, message, link, className }: IProps) => (
  <Container className={className}>
    <SvgIcon
      name="dictionary-no-results"
      width={iconSize}
      height={iconSize}
      customFill={theme.colors.secondary800}
    />
    <TextBox>
      <Message>{message}</Message>
      {link && (
        <StyledLink href={link} target="_blank" rel="noopener noreferrer">
          More Info
        </StyledLink>
      )}
    </TextBox>
  </Container>
);

export default NoDataPlaceholder;
